import React, { useEffect, useState, useMemo } from "react";
import { Link } from "gatsby";
import { useLocation } from "@reach/router";
import styled from "styled-components";
import Icon_Home from "~/images/Icon_Home.png";
import Icon_Download from "~/images/Icon_Download.png";
import Icon_Promotion from "~/images/Icon_Promotion.png";
import Icon_Credit from "~/images/Icon_Credit.png";
import icon_Line from "~/images/Icon_Line.png";

const WrapperNavigator = styled.div`
  position: fixed;
  bottom: 0;
  height: 60px;
  width: 100%;
  background: ${(props) => props.theme.background};
  z-index: 9999;
  color: black;
`;

const Grid = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  .active {
    border-top: 2px solid white;
  }
`;

const IconNav = styled.div`
  background-size: contain;
  color: #fff;

  img {
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2px;
    width: 25px;
    height: 20px;
  }
`;

const NavigatorTheme = {
  live22: {
    background:
      "transparent linear-gradient(180deg, #0396ff 0%, #0080db 100%) 0% 0% no-repeat padding-box",
    color: "#0396ff",
  },
  slotxo: {
    background:
      "transparent linear-gradient(180deg, #E40203 0%, #960E10 100%) 0% 0% no-repeat padding-box",
    color: "#E40203",
  },
  pgslot: {
    background:
      "transparent linear-gradient(180deg, #28BC7B 0%, #3DB741 100%) 0% 0% no-repeat padding-box",
    color: "#28BC7B",
  },
  joker: {
    background:
      "transparent linear-gradient(180deg, #FF12A4 0%, #DA0055 100%) 0% 0% no-repeat padding-box",
    color: "#FF12A4",
  },
  ambslot: {
    background:
      "transparent linear-gradient(180deg, #FAEB57 0%, #E59801 100%) 0% 0% no-repeat padding-box",
    color: "#FFB503",
  },
};

const NavigatorBottomComponent = () => {
  const { pathname } = useLocation();
  const currentPath = pathname;
  const [currentPage, setCurrentPage] = useState("live22");
  const [currentUrl, setCurrentUrl] = useState("");

  const subMenuList = [
    { path: "/", textVal: "หน้าหลัก", icon: Icon_Home },
    { path: "/#download", textVal: "ดาวโหลด", icon: Icon_Download },
    { path: "/promotion", textVal: "โปรโมชั่น", icon: Icon_Promotion },
    { path: "/credit", textVal: "เครดิตฟรี", icon: Icon_Credit },
    { path: "/contact", textVal: "ติดต่อเรา", icon: icon_Line },
  ];

  useMemo(() => {
    if (
      [
        "/",
        "/#anchorDownload",
        "/promotion",
        "/credit",
        "/contact",
        "/login",
        "/register",
        "/login/",
        "/register/",
      ].includes(currentPath)
    )
      setCurrentPage("live22");
    else setCurrentPage(currentPath.split("/")[1]);
  }, [currentPath]);

  useEffect(() => {
    if (
      ["anchorDownload", "promotion", "credit", "contact", "live22"].includes(
        currentPage
      )
    )
      setCurrentUrl("");
    else setCurrentUrl(currentPath.split("/")[1]);
  }, [currentPath]);

  return (
    <WrapperNavigator
      className="grid grid-cols-5 lg:hidden md:hidden"
      theme={NavigatorTheme[currentPage]}
    >
      {subMenuList.map((items, index) => (
        <Grid key={index}>
          <Link
            key={index}
            to={`${
              currentUrl === ""
                ? `${currentUrl}${items.path}`
                : `/${currentUrl}${items.path}`
            }`}
            activeClassName="active"
          >
            <IconNav className="block text-center cursor-pointer">
              <img src={items.icon} alt="" />
              {items.textVal}
            </IconNav>
          </Link>
        </Grid>
      ))}
    </WrapperNavigator>
  );
};

export default NavigatorBottomComponent;
